import React, { Component } from "react";
import MessageRowItemContainer from "./messaging-row-item-container";
import MessageThread from "./messaging-thread";

export default class ConversationListItem extends Component {
  constructor(props) {
    super(props);

    this.togglePreview = this.togglePreview.bind(this);
    this.archive = this.archive.bind(this);
  }

  togglePreview() {
    this.props.onclick(this.props.thread.conversation_id);
  }

  archive() {
    this.props.archive(this.props.thread.conversation_id);
  }

  render() {
    const { thread, showQuickReply } = this.props;
    const message = thread.messages[0];
    const textOnly = message.content && message.content.replace(/<[^>]+>/g, "");

    if (this.props.preview) {
      return (
        <MessageRowItemContainer
          logo={thread.conversation_brand_logo}
          brandName={thread.conversation_brand_name}
          brandId={message.conversation_brand_id}
          userName={thread.fromNames}
          heading={message.heading}
          text={textOnly}
          timestamp={thread.last_message_at}
          clickFunction={this.togglePreview}
          highlight={!thread.read}
          status={message.partnership_action ? null : message.status}
          archiveOption={true}
          archiveFunction={this.archive}
        />
      );
    } else {
      return (
        <MessageThread
          messages={thread.messages}
          collapse={this.togglePreview}
          conversationId={thread.conversation_id}
          showQuickReply={showQuickReply}
          conversationLastMessage={thread.last_message_at}
          targetBrandId={thread.conversation_brand_id}
        />
      );
    }
  }
}
